import setSearchText from './searchText/setSearchText';
import datapoints from '../datapoints';
import getCanAddMoreSuggestionPills from '../helpers/getCanAddMoreSuggestionPills';
import { logUsage } from 'owa-analytics';
import { getStore, defaultSearchStore } from 'owa-mail-search-store';
import { SuggestionKind } from 'owa-search-service';
import { action } from 'satcheljs/lib/legacy';
/**
 * Removes the suggestion from the suggestionPillIds list and the suggestionPills for the given pill id.
 * @param id - id of the pill to remove
 */
export var removePill = action('removeSearchPill')(function removePill(id) {
    var state = getStore();
    var index = state.suggestionPillIds.indexOf(id);
    if (index == -1) {
        throw new Error('removePill should not be called when the suggestion is not present in the suggestion list');
    }
    var suggestion = state.suggestionPills.get(id);
    logUsage(datapoints.RemoveSuggestionPillAction.datapoint.name, datapoints.RemoveSuggestionPillAction.datapoint.customData(SuggestionKind[suggestion.kind]));
    state.suggestionPills.delete(id);
    state.suggestionPillIds.splice(index, 1);
    state.selectedSuggestionIndex = defaultSearchStore.selectedSuggestionIndex;
});
/**
 * Add suggestion to the suggestionPillIds list and suggestionPills
 * @param pillSuggestion Pill Suggestion
 */
export var addPill = action('addSearchPill')(function addPill(pillSuggestion) {
    if (!getCanAddMoreSuggestionPills()) {
        return;
    }
    var pillId = pillSuggestion.ReferenceId;
    var state = getStore();
    // Only add suggestion to suggestion pills if it was not already added
    // And set the search text to empty as user picked up the rich suggestion from the suggestions menu
    // that were based on what he was typing. We want to do it here because it should
    // only be done when we actually end up adding the suggestion
    if (state.suggestionPillIds.indexOf(pillId) == -1) {
        state.suggestionPills.set(pillId, pillSuggestion);
        state.suggestionPillIds.push(pillId);
        setSearchText('');
    }
    logUsage(datapoints.AddSuggestionPillAction.datapoint.name, datapoints.AddSuggestionPillAction.datapoint.customData(SuggestionKind[pillSuggestion.kind]));
});
//# sourceMappingURL=suggestionPillActions.js.map